// extracted by mini-css-extract-plugin
export default {"flowyFigure":"FlowyFigure_flowyFigure__akOEY"};